// import branch from 'branch-sdk';
import moment from 'moment-timezone';
import React, { useEffect, useState } from "react";
import Accordion from 'react-bootstrap/Accordion';
import Button from "react-bootstrap/Button";
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import { useSelector, useDispatch } from 'react-redux';
import { SET_WIDGET_STRIPE_ACCOUNT } from 'store/reducers/widgetReducer'
import analytics from 'util/analytics';
import "./ClassCheckout.scss";
import "./OnDemandCheckout.scss";
import Section from "./Section";
import { getClassCheckout } from 'util/api/CheckoutAPI'
import { useAuth } from 'util/auth'
import OfferingSelector from 'components/OfferingSelector'
import {LoginSignupForm} from 'components/AccountButton'
import { checkoutClass } from 'util/api/CheckoutAPI'
import CardSection from 'components/CardSection'
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import PaymentMethodSelector from 'components/PaymentMethodSelector'
import CheckoutPricingSection from 'components/CheckoutPricingSection'
import Image from 'react-bootstrap/Image'
import {ADD_USER_RESERVATION} from 'store/reducers/userReducer'
import ShareButton from 'components/ShareButton'
import VideoPlayer from 'components/VideoPlayer'
import {sendNewError} from 'util/slackbot'
import {ExpandableTerms} from 'components/ClassCheckout'
import {useChallenge} from 'util/challengeWidgetProvider'
import {calculateDiscountFrom} from 'components/CheckoutPricingSection'
import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { pdfjs } from 'react-pdf';
import { SizeMe } from 'react-sizeme'
import {useWidget} from 'util/widget'
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder'
import FavoriteIcon from '@material-ui/icons/Favorite';
import {createBookmark, deleteBookmark} from 'store/actions/widgetActions'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

var HtmlToReactParser = require('html-to-react').Parser;
var htmlToReactParser = new HtmlToReactParser(); 

function urlify(text) {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, function(url) {
      return '<a className="primaryColor" target="_blank" href="' + url + '">' + url + '</a>';
    })
    // or alternatively
    // return text.replace(urlRegex, '<a href="$1">$1</a>')
}

function OnDemandCheckout(props) {
    const { history, match } = props;

    const auth = useAuth()
    const stripe = useStripe()
    const elements = useElements()
    const dispatch = useDispatch()
    const widget = useWidget()
    // const [runningtotal, setrunningtotal] = useState(0);
    const [takeonfee, settakeonfee] = useState(true);
    const [marketingEmails, setMarketingEmails] = useState(true);
    const [agreeToTerms, setAgreeToTerms] = useState(false);
    const stripeAccountId = useSelector(state => state.widget.stripeAccount)
    const [isLoading, setIsLoading] = useState(false)
    const [selectedPaymentMethod, setSelectedPaymentMethod] = React.useState(null)
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    const classID = props.match.params.platformID

    moment.locale('en', {
        calendar : {
            lastDay : '[Yesterday at] LT',
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            lastWeek : '[last] dddd [at] LT',
            nextWeek : 'dddd [at] LT',
            sameElse : 'dddd MMM Do'
        }
    });

    const isBookmarked = useSelector(state => state.widget.bookmarksMap[classID])
    const [isBookmarkSaving, setIsBookmarkSaving] = React.useState(false)
    const handleBookmarkClick = () => {
        if (isBookmarked) {
            setIsBookmarkSaving(true)
            dispatch(deleteBookmark(classID))
                .then(result => {
                    setIsBookmarkSaving(false)
                })
        } else {
            setIsBookmarkSaving(true)
            dispatch(createBookmark(classID))
                .then(result => {
                    setIsBookmarkSaving(false)
                })
        }
    }

    const listedSelectedClass = useSelector(state => state.widget.onDemands.find(val => val.platformID === classID));

    const [serverSelectedClass, setServerSelectedClass] = React.useState(null)
    const selectedClass = listedSelectedClass ? listedSelectedClass : serverSelectedClass
    const selectedInstructor = useSelector(state => state.widget.instructor);
    const reservationsMap = useSelector(state => state.user.reservations.reduce((map, obj)=> {
        if (obj?.canceled === true) {
            return map
        }
        if (obj.serverReservationObjectId) {
            map[obj.serverReservationObjectId] = obj
        }
        return map
    },{}))
    const ownedOfferings = useSelector(state => state.user.ownedOfferings)
    const ownedChallenges = useSelector(state => state.user.ownedChallenges)
    // const class_name = selectedClass ? selectedClass.class_name : "" 
    // const { class_name } = selectedClass ? selectedClass : null;
    useEffect(() => {
        analytics.page({
            title: 'On Demand Checkout'
        })
        analytics.track("Pre Purchase Viewed", {...selectedClass})
    }, [selectedClass])

    const [checkoutModel, setCheckoutModel] = React.useState({}) // JARCH: drop-in, class pack, etc.. 
    const [userCouponCode, setUserCouponCode] = React.useState(null)
    const handleCouponCodeChange = (couponCode) => {
        setUserCouponCode(couponCode)
    }
    const handleCouponCodeApply = () => {
        setIsLoading(true)
        getClassCheckout(classID, userCouponCode, widget.widgetName)
            .then(data => {
                setIsLoading(false)
                console.log("stripeaccount: ", data.stripeAccount)
                if (data.success) {
                    console.log("coupon code data: ", data)
                    setCheckoutData(data)
                }
                if (data.class) {
                    setServerSelectedClass(data.class)
                }
                dispatch({type: SET_WIDGET_STRIPE_ACCOUNT, stripeAccount: data?.stripeAccount})
            })
            .catch(err => {
                console.log("standard checkout error: ", err)
                setIsLoading(false)
                // window.alert("Error fetching checkout. Please refresh the page.")
            })
    }

    const [checkoutData, setCheckoutData] = React.useState(null) // data from checkout
    useEffect(() => {
        if (!widget?.widgetName) {
            return
        }
        setIsLoading(true)
        getClassCheckout(classID, userCouponCode, widget.widgetName)
            .then(data => {
                // console.log(data)
                setIsLoading(false)
                if (data.success) {
                    console.log("standard checkout data: ", data)
                    setCheckoutData(data)
                }
                if (data.class) {
                    setServerSelectedClass(data.class)
                }
                dispatch({type: SET_WIDGET_STRIPE_ACCOUNT, stripeAccount: data?.stripeAccount})
            })
            .catch(err => {
                setIsLoading(false)
                window.alert("Error fetching checkout. Please refresh the page.")
            })
    }, [auth?.userData, widget?.widgetName])
    var viewModel = {}

    if (selectedClass) {
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        let location = "";
        switch (selectedClass.location_type) {
        case "inperson":
            location = selectedClass.location?.cityState ?? "In-Person"
            break
        default:
            location = "LIVESTREAM"
            break
        }
        // console.log("selected class: ", selectedClass)
        let airedOnTime = moment((selectedClass.start_time ?? selectedClass.created) * 1000)
        let dateString = airedOnTime.calendar() + ` ${moment.tz(moment.tz.guess()).format('z')}`

        var expiresAtTime = selectedClass?.expirationDate ? moment(selectedClass.expirationDate * 1000) : null
        var expiresAtString = null
        if (expiresAtTime && expiresAtTime < moment().add('year', 1)) {
            expiresAtString = `Expires ` + expiresAtTime.calendar()
        }
        // let calculatedFeeString = formatter.format(calculatedFee)
        // let runningtotalstring = formatter.format(runningTotal)
        let isFree = (selectedClass.price === 0 && !selectedClass.isDonation && selectedClass.purchase_type?.toLowerCase() !== 'donation')
        selectedClass.isDonation = (selectedClass.purchase_type || "").toLowerCase() === "donation" || selectedClass.isDonation
        if (selectedClass?.onDemand?.downloadUrl && selectedClass.onDemand.downloadUrl.includes("spotify") && !selectedClass.onDemand.downloadUrl.includes('embed')) {
            selectedClass.onDemand.downloadUrl = selectedClass.onDemand.downloadUrl.replace(`playlist`, `embed/playlist`)
        }

        var selectedPrice = checkoutModel.payment
        const discount = calculateDiscountFrom(checkoutModel, checkoutData?.couponCodeResponse)
        if (discount) {
            selectedPrice = selectedPrice - discount
        }

        const requirePayment = ((selectedPrice ?? 0) > 0) || (checkoutModel?.type === 'subscription' && (checkoutModel?.payment ?? 0) > 0)

        viewModel = {
            isSubscriptionOnly: (!selectedClass?.allowsDropin && !selectedClass?.allowsRental),
            shareLink: selectedClass.challengeId ? null : `${process.env.REACT_APP_BOOKING_CANCEL_URL}${match.url}`,
            platformID: selectedClass.platformID,
            name: selectedClass.name || selectedClass.class_name || "Class",
            timeString: dateString,
            expiresAtString: expiresAtString,
            image: (selectedClass.images && selectedClass.images.length > 0) ? selectedClass.images[0] : "",
            instructorName: selectedInstructor?.instructorProfile?.pageName ?? selectedClass?.instructor_name,
            location: selectedClass.location?.cityState ?? "LIVESTREAM",
            description: htmlToReactParser.parse(urlify(selectedClass.description ?? selectedClass.class_about ?? "")),
            priceText: () => {

                if (selectedClass.isSubscriptionOnly) {
                    return ""
                }
                return selectedClass?.purchase_type?.toLowerCase() === 'donation' ? "Sliding Scale" : (isFree ? "" : formatter.format(selectedClass.price))
            },
            
            takeonfee: takeonfee,
            marketingOptIn: marketingEmails,
            agreeToTerms: agreeToTerms,
            showPayment: requirePayment,
            nextbuttonstring: requirePayment ? "Purchase & Unlock Content" : "Unlock Content",
            // showPayment: (checkoutModel?.payment ?? 0) > 0,
            // nextbuttonstring: ((checkoutModel?.payment ?? 0) > 0) ? "Purchase & Unlock Content" : "Unlock Content",
            isRental: selectedClass.isRental ?? false,
            rentalPeriodHours: selectedClass.rentalPeriodHours ?? 99999,
            showMarketingOptIn: checkoutData?.showMarketingOptIn,
            userCouponCode: userCouponCode,
            workoutTypes: (selectedClass?.workout_types ?? []).join(", ")
        }

        if (checkoutData?.requiresWaiver) {
            viewModel.liabilityWaiverText = selectedInstructor?.instructorProfile?.liabilityWaiverTextHTML ?? selectedInstructor?.instructorProfile?.liabilityWaiverText
        }

        const cantreservetheseclasses = ["Qks5jmZFhZMWJZwqqNMo","iuCUcdcDYnT3HVJs8Jw5","N45MGphdqLTrgftu19hD","LTsdwq9FMGVmeFbfotYy","tTorLTUY9JOWQnhthSq4","64bPKumVuUJqSkw9AqYi","Ck1Jlcors4akEJWWYAIP","ASNzfS5UByiUgleQTtpV","TeaoTfXYDTG2Yw9fq2Gi","RQlT0W346ijIqKQ3MjIG","ha2RLMqxlwGHQDhZcdxm","3wewQYeqCDzw2sCdta07","OknNWRb9TK2T6ZmkLCe4","mA1uZxiTs0B31607c485"
        ]
        if (cantreservetheseclasses.includes(selectedClass.id)) {
            viewModel.nextbuttonstring = "Class is Full"
            viewModel.disableCheckout = true
        }
        if (reservationsMap[selectedClass.id] || (selectedClass.classId && reservationsMap[selectedClass.classId]) || checkoutData?.unlockVideo) {
        // if (true) {
            viewModel.unlockVideo = true
            viewModel.objectSnapshot = selectedClass
            viewModel.classId = selectedClass.id
        }
        if (ownedOfferings[selectedClass.challengeId] || ownedChallenges[selectedClass.challengeId]) {
            viewModel.unlockVideo = true
            viewModel.objectSnapshot = selectedClass
            viewModel.classId = selectedClass.id
        }

        // if (selectedClass?.mux?.status === 'status' && selectedClass?.mux?.playback_ids) {
        if (selectedClass?.mux?.playback_ids) {
            console.log("mux playback ids: ", selectedClass.mux.playback_ids)
            const public_playback = selectedClass.mux.playback_ids.find(val => val.policy === 'public')
            // .map(val => val.id)
            viewModel.playback_id = public_playback?.id
        }

        // if (checkoutData?.unlockVideo || reservationsMap[selectedClass.id] || (selectedClass.classId && reservationsMap[selectedClass.classId])) {
        // if (true) {
        //     viewModel.userHasAlreadyReservedThisClass = true
        //     viewModel.objectSnapshot = selectedClass
        //     viewModel.classId = selectedClass.id
        // }
    }
    
    function nextButtonClicked() {
        console.log("clicked next")

        if (viewModel.disableCheckout) {
            window.alert("disabled")
            return
        }
        if (!auth.userData) {
            window.alert("Must be logged in to book this class")
            return
        }

        if (viewModel.liabilityWaiverText && !viewModel.agreeToTerms) {
            window.alert("Must agree to liability waiver")
            return
        }

        // console.log("CHECKOUT MODEL: ", checkoutModel)
        // console.log("VIEW MODEL: ", viewModel)

        const dataToCheckout = {
            ...checkoutModel,
            ...viewModel
        }
        checkoutHandler(dataToCheckout)
    }

    async function checkoutHandler(val) {

        setIsLoading(true)

        try {

            let paymentMethod = selectedPaymentMethod?.id
            // if (val.payment > 0) {
            if (val.showPayment) {
                
                if (!selectedPaymentMethod) { // requires payment with new card
                    const cardElement = elements.getElement(CardElement);
                    const paymentMethodReq = await stripe.createPaymentMethod({
                        type: 'card',
                        card: cardElement
                    }, {
                        stripeAccount: stripeAccountId
                    })
        
                    console.log("paymentMethodReq: ", paymentMethodReq)
                    
                    if (paymentMethodReq.error?.message) {
                        await sendNewError(JSON.stringify({
                            error: paymentMethodReq.error.message,
                            code: paymentMethodReq.error.code,
                            decline_code: paymentMethodReq.error.decline_code,
                            location: "Creating payment method -- On Demand checkout",
                            user: auth?.userData?.email,
                            host_name: selectedClass?.host_name,
                            classId: classID
                        }))
                        setIsLoading(false)
                        window.alert(paymentMethodReq.error.message)
                        return
                    }
                    
                    paymentMethod = paymentMethodReq.paymentMethod.id

                    if (val.type === "subscription") {
                        // setup card for future use.. 
                        //      Done server side
                    }
                }

            }
            

            var data = {
                ...val,
                // name: val.name,
                // description: `Class with ${val.instructorName}\n${val.timeString}`,
                // images: val.images,
                // runningTotal: Math.round(val.runningTotal * 100),
                paymentMethod: paymentMethod,
                willTakeOnPayment: val.takeonfee,
                agreeToBeContacted: val.marketingOptIn,
                userID: auth.userData.platformID,
                id: val.platformID,
                bookingType: "class",
                collection: "classes",
                bookingLocation: "widget",
                success_url: `${process.env.REACT_APP_BOOKING_SUCCESS_URL}${match.url}`,
                cancel_url: `${process.env.REACT_APP_BOOKING_CANCEL_URL}${match.url}`,
                customer_name: auth.userData.firstName,
                customer_email: auth.userData.email
            }

            // console.log("checkout data: ", data)

            // return


            const response = await checkoutClass(data.id, data)
            if (!response.success) {
                // console.log(response)
                await sendNewError(JSON.stringify({
                    error: response,
                    user: auth?.userData?.email,
                    host_name: selectedClass?.host_name,
                    classId: classID
                }))
                setIsLoading(false)
                if (response.message?.raw?.message) {
                    window.alert(response.message.raw.message)
                    
                } else {
                    window.alert(response.message)
                }
                return
            }

            const {sessionId, message, reservation, reservationId, connectAccountId, clientSecret} = response;

            console.log("REsponse from checkout: ", response)
            if (sessionId) {
                setIsLoading(false)
                window.alert("We shouldn't be using sessionId anymore.. ")

            } else if (clientSecret) {

                const confirmedCardPayment = await stripe.confirmCardPayment(clientSecret, {
                    payment_method: paymentMethod,
                    setup_future_usage: "off_session"
                }, {
                    stripeAccount: stripeAccountId
                })

                setIsLoading(false)


                if (confirmedCardPayment.error) {
                    await sendNewError(JSON.stringify({
                        message: confirmedCardPayment.error.message,
                        user: auth?.userData?.email,
                        host_name: selectedClass?.host_name,
                        classId: classID
                    }))
                    setIsLoading(false)
                    if (confirmedCardPayment.error.decline_code === 'do_not_honor') {
                        window.alert("Your card was declined due to the error `Do hot honor`. Please contact your bank to approve this charge and try again or use another card.")
                    } else {
                        window.alert(confirmedCardPayment.error.message)
                    }
                    return
                }

                handleSuccessfulPayment(data, reservationId, reservation)
            } else if (reservationId) {
                setIsLoading(false)
                handleSuccessfulPayment(data, reservationId, reservation)
            } else if (message) {
                
                await sendNewError(JSON.stringify({
                    message: message,
                    user: auth?.userData?.email,
                    host_name: selectedClass?.host_name,
                    classId: classID
                }))
                setIsLoading(false)
                window.alert(message)
            } else {
                setIsLoading(false)
                window.alert("Something went wrong after succesful api response")
            }
        } catch (err) {
            await sendNewError(JSON.stringify({
                error: err,
                user: auth?.userData?.email,
                host_name: selectedClass?.host_name,
                classId: classID
            }))
            setIsLoading(false)
            console.log("wuh oh")
            console.log(err)
            if (err.message) {
                window.alert(err.message)
            } else {
                window.alert(err)
            }
        }
    }
    const challengeWidget = useChallenge()
    const selectedChallenge = challengeWidget?.challenge

    function handleSuccessfulPayment(data, resId, reservation) {

        const analyticsData = {
            pixelId: selectedInstructor?.instructorProfile?.facebookPixelId,
            value: data.payment,
            name: data.name,
            classId: data.id,
            currency: 'USD',
            location: 'OnDemandCheckout',
            type: data.type, // pack, dropin, subscription
            offering: data?.offering?.name ?? 'none',
            offeringId: data?.offering?.id ?? 'none'
        }
        analytics.track('bookingSuccess',analyticsData)
        analytics.track('Purchase', analyticsData)

        if (reservation) {
            reservation.serverReservationObjectId = reservation.id
            dispatch({type: ADD_USER_RESERVATION, reservation: reservation})
        } else {
            handleCouponCodeApply()
        }
    }

    const submit = (event) => {
        event.preventDefault();
        nextButtonClicked();
    }

    let height;
    const sendPostMessage = () => {
        let conatinerId = "fullWidthWidget"
        if (document.getElementById(conatinerId)) {
            if (height !== document.getElementById(conatinerId).offsetHeight) {
                height = document.getElementById(conatinerId).offsetHeight;
                window.parent.postMessage({
                  frameHeight: height
                }, '*');
                // console.log(height);
              }
        }
        
    }
    useEffect(() => {
        sendPostMessage()
    })
    return (

        <Section
        textColor="dark"
        size="sm"
        className="text-left"
        >
            <div>
            {(selectedClass) ? (
                // <form onSubmit={submit}>
                <div>
                    
                    {/* // JARCH start */}
                    {viewModel.unlockVideo ? (
                        <Section
                        // className="mt-4"
                        >

                            <h3 className="classTitle mb-3">{viewModel.name}</h3>
                            <div className="mb-3">
                                {selectedClass?.onDemand?.downloadUrl && (
                                    
                                    <>
                                    {selectedClass.onDemand.fileType.includes("video") ? (<>
                                        {false ? (
                                            <video className="w-100" controls autoPlay name="media">
                                                <source type={selectedClass.onDemand.fileType} src={selectedClass.onDemand.downloadUrl}></source>
                                            </video>
                                        ) : (<>

                                            <VideoPlayer
                                                previewImage={viewModel.image}
                                                playback_id={viewModel.playback_id}
                                                src={selectedClass.onDemand.downloadUrl}
                                                type={selectedClass.onDemand.fileType}
                                                classId={selectedClass?.platformID}
                                                instructorId={selectedClass?.instructor_id}
                                                instructor={viewModel.instructorName}
                                            />

                                            {selectedChallenge?.id === '39RMMwzetXOAFnWhI2VD' && (
                                                <img src="https://via.placeholder.com/800x1600.jpg" className="mx-auto my-5" alt="Nature" style={{width: "80%", height: "500px"}} /> 
                                            )}
                                        </>)
                                        }
                                        
                                    </>) : (
                                    <>
                                        {selectedClass.onDemand.downloadUrl.includes("spotify") ? (
                                            <iframe
                                            src={selectedClass.onDemand.downloadUrl}
                                            frameborder="0" 
                                            width="100%" height="100%"  
                                            style={{width: "100%", height:"600px"}}
                                            allow="encrypted-media"></iframe>
                                        ) : (
                                        <>
                                            <a href={selectedClass.onDemand.downloadUrl} target="_blank" className="btn btn-primary primaryColor mb-2">Download File</a>
                                            {selectedClass.onDemand.downloadUrl.includes("pdf") && (
                                                <SizeMe >
                                                    {({ size }) => (
                                                        <Document className="mb-5" file={selectedClass.onDemand.downloadUrl}>
                                                            <Page pageNumber={pageNumber} width={size.width ? size.width : 1} />
                                                        </Document>
                                                    )}
                                                </SizeMe>
                                            )}
                                        </>
                                        )}
                                        
                                    
                                    </>
                                    )}
                                    </>
                                )}
                            </div>

                            <div className="mb-3 row">
                                <div className="col-md-12">
                                    <div className='d-flex d-column mb-3'>
                                        <button disabled={isBookmarkSaving} onClick={handleBookmarkClick} className={(isBookmarked ? "btn btn-primary" : "btn btn-outline-primary") + " primaryColor mr-3"}>
                                            {isBookmarked ? (
                                                <>
                                                    <FavoriteIcon className="mr-2"/>
                                                    <span>Favorited</span>
                                                </>) : (
                                                <>
                                                    <FavoriteBorderIcon className="mr-2"/>
                                                    <span>Add to Favorites</span>
                                                </>
                                            )}
                                        </button>

                                        <ShareButton link={viewModel.shareLink} buttonText="Share" />
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-9">
                                    
                                    <p className="my-0">{viewModel.timeString}</p>
                                    {viewModel.expiresAtString && (
                                        <p className="my-0">{viewModel.expiresAtString}</p>
                                    )}
                                    <h6 className="my-0">{viewModel.instructorName}</h6>
                                    {viewModel.description && viewModel.description.length > 0 && (
                                        <div className="card-text" style={{whiteSpace: "pre-line"}}>{viewModel.description}</div>
                                    )}
                                </div>

                            </div>

                        </Section>
                    ) : (<>
                    <div className="row">
                       
                        <div className="col-sm-12 col-md-6 col-lg-6"> 
                            <div>
                                <div className='d-flex d-column justify-content-between'>
                                    <h6 className="classTitle mb-1">{viewModel.name}</h6>
                                    <h6 className="mb-1">{viewModel.priceText}</h6>
                                </div>
                                
                                <p className="my-0">{viewModel.timeString}</p>
                                {viewModel.expiresAtString && (
                                    <p className="my-0">{viewModel.expiresAtString}</p>
                                )}
                                {viewModel.isRental && viewModel.rentalPeriodHours && (
                                    <p className="my-0">RENTAL - Expires after {viewModel.rentalPeriodHours} hours</p>
                                )}
                                <p className="my-0">{viewModel.instructorName}</p>
                                {/* <p className="my-0">{viewModel.location}</p> */}
                                {viewModel.description && viewModel.description.length > 0 && (
                                    <Accordion>
                                        <Accordion.Toggle as={Button} variant="link" eventKey="0" className='primaryColor m-0 p-0'>
                                            View Details
                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="0">
                                            <p style={{whiteSpace: "pre-line"}}>{viewModel.description}</p>
                                        </Accordion.Collapse>
                                    </Accordion>
                                )}
                            </div>
                            <hr/>
                            <div
                                style={{height: "0px",
                                overflow: "hidden",
                                paddingTop: "56.25%",
                                background: "white",
                                position: "relative"}}
                            >
                                <div style={{
                                    position: "absolute",
                                    boxShadow: "1px 1px 0 0 #efefef",
                                    top: "0",
                                    left: "0",
                                    width: "100%",
                                    height: "100%"}}>
                                        <Image 
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover", overflow: "hidden"}}
                                        src={viewModel.image && viewModel.image !== "" ? viewModel.image : "https://via.placeholder.com/1600x900.jpg"} />
                                </div>
                                
                            </div>

                            

                        </div>

                        <div className="col-sm-12 col-md-6 col-lg-6"> 
                            {checkoutData && !viewModel.disableCheckout && (
                                <>
                                <Form.Group>
                                    <OfferingSelector
                                    {...checkoutData}
                                    onChange={(model) => {
                                        setCheckoutModel(model)
                                    }}
                                    />
                                </Form.Group>
                                <hr/>
                                </>
                            )}
                            <LoginSignupForm
                            mode={'signin'}
                            onComplete={() => "Logged in successfully"}
                            />


                    

                            <div className='mt-3'>
                                <Form.Group>
                                    {viewModel.liabilityWaiverText && (<>
                                        <br></br>
                                        <ExpandableTerms terms={viewModel.liabilityWaiverText} />
                                        <Form.Check 
                                        checked={agreeToTerms}
                                        // className="primaryColor"
                                        type="checkbox"
                                        id="terms-checkbox"
                                        onChange={(e) => setAgreeToTerms(e.target.checked)}
                                        label={`I agree to the Liability Waiver`}
                                    />
                                    </>)}

                                    {viewModel.showMarketingOptIn && (
                                        <Form.Check 
                                            checked={marketingEmails}
                                            // className="primaryColor"
                                            type="checkbox"
                                            id="marketing-switch"
                                            onChange={(e) => setMarketingEmails(e.target.checked)}
                                            label={`I agree to receive newsletters + product updates from ${viewModel.instructorName}.`}
                                        />
                                    )}
                                </Form.Group>
                            </div>
                            <hr/>
                            {viewModel.showPayment && checkoutData?.paymentMethods && (
                                <Form.Group>
                                    <PaymentMethodSelector
                                    {...checkoutData}
                                    paymentMethods={checkoutData.paymentMethods}
                                    // onChange={(model) => console.log(`got the model: ${model}`)}
                                    onChange={(model) => {
                                        // console.log(model)
                                        setSelectedPaymentMethod(model)
                                    }}
                                    />
                                </Form.Group>
                            )}
                            {viewModel.showPayment && !selectedPaymentMethod && (
                                <CardSection className="w-100 mb-5" />
                            )}

                            {checkoutData && checkoutModel && !viewModel.disableCheckout && (
                                <CheckoutPricingSection
                                checkoutData={checkoutData}
                                checkoutModel={checkoutModel}
                                handleCouponCodeChange={handleCouponCodeChange}
                                handleCouponCodeApply={handleCouponCodeApply}
                                isLoading={isLoading}
                                />
                            )}
                            
                            <div className="d-flex flex-row justify-content-center">
                                <Button disabled={isLoading || viewModel.disableCheckout} onClick={() => nextButtonClicked()} style={{width: "50%"}} className="primaryColor my-4" variant="primary">
                                    {viewModel.nextbuttonstring}
                                    {isLoading && (
                                        <Spinner
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden={true}
                                        className="ml-2"
                                    >
                                        <span className="sr-only">Sending...</span>
                                    </Spinner>

                                    )}
                                </Button>
                            </div>

                        </div>

                    </div>
                    </>)}
                </div>
            ) : (
                <div className='align-self-stretch container text-center my-auto pt-5'>
                    <Spinner className='mt-5' animation="grow"/>
                </div>
            )}
        </div>
        </Section>
    );
}

export default OnDemandCheckout;
